import React from 'react';
import { PlayCircleIcon } from '@fronton/icons-react';
import { transformVideoThumb } from 'utils/transform-video-thumb';
import { thumb, videoThumbIcon, videoThumbBg, videoThumbIconBg } from './styles';
import { useOptimisedImages } from '@navi-toolbox/hooks';

type Props = {
  src: string;
  index: number;
  onClick: (mediaType: string, imgSrc: string, index: number) => void;
};

function ThumbVideo({ src, index, onClick }: Props) {
  const videoSrc = transformVideoThumb(src);

  const optimizedImage = useOptimisedImages({
    src: videoSrc,
    sizes: {
      thumb: {
        h: '160',
        w: '169',
      },
    },
  });

  function handleClick() {
    onClick?.('mediaVideo', src, index);
  }

  return (
    <div data-qa="thumb-item-video" onClick={handleClick} className={thumb}>
      <PlayCircleIcon
        className={videoThumbIcon}
        type="fill"
        color="background-secondary"
        size="xxl"
        data-qa="thumb-icon"
      />
      {videoSrc ? (
        <div
          className={videoThumbBg}
          style={{
            backgroundImage: `url(${optimizedImage.thumb.x})`,
          }}
        />
      ) : (
        <div className={videoThumbIconBg} />
      )}
    </div>
  );
}

export { ThumbVideo };
